import Slider, { invocaRcSliderOverrides } from './Slider';

export { invocaRcSliderOverrides };

export default Slider;
